import React, {useRef} from 'react';
import {Header} from './Components/Header/Header';
import {classes, st} from './SideCart.st.css';
import {Footer} from './Components/Footer/Footer';
import {Body} from './Components/Body/Body';
import './vars.scss';
import {SideCartAppDataHook, SideCartProps} from './SideCart.types';
import {ErrorToast} from '../../../common/components/ErrorToast/ErrorToast';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {PriceBreakdown} from './Components/PriceBreakdown/PriceBreakdown';
import {CustomerInputSection} from './Components/CustomerInputSection/CustomerInputSection';
import {SlotPlaceHolder} from '../../../common/components/SlotPlaceHolder/SlotPlaceHolder';
import {SlotsMap} from '../../../common/constants';
import {useSlotPlaceholder} from '@wix/widget-plugins-ooi';

export const SideCart = ({dir}: SideCartProps) => {
  const editorBrand = window?.commonConfig?.brand;
  const isStudioOrEditorXSite = editorBrand === 'editorx' || editorBrand === 'studio';
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const onRemoveItem = () => closeButtonRef?.current?.focus();
  const {t} = useTranslation();
  const [, isEmpty] = useSlotPlaceholder(SlotsMap.SideCartCustomerInputAfter1);
  const shouldShowCustomerInputAfter1Slot = !isEmpty;

  const {sideCartNote, sideCartCouponAndNote, shouldRenderEmptyState, addSlotsToSideCart} =
    useControllerProps().cartStore;
  const shouldRenderCustomerInputSection =
    (sideCartCouponAndNote || sideCartNote || (addSlotsToSideCart && shouldShowCustomerInputAfter1Slot)) &&
    !shouldRenderEmptyState;
  const shouldRenderPriceBreakdown = sideCartCouponAndNote && !shouldRenderEmptyState;

  return (
    <main
      dir={dir}
      aria-label={t('sideCart.mainFrame.ariaLabel')}
      data-hook={SideCartAppDataHook.root}
      className={st(
        'cartBodyMainOneColumn',
        'sideCart',
        classes.container,
        ...(isStudioOrEditorXSite ? [classes.responsiveEditor] : [])
      )}
      data-wix-side-cart>
      <div className={shouldRenderCustomerInputSection ? classes.headerAndBody : classes.headerAndBodyOld}>
        <Header closeButtonRef={closeButtonRef} />
        {addSlotsToSideCart && (
          <SlotPlaceHolder slotId={SlotsMap.SideCartHeaderAfter1} className={classes.headerAfter1Slot} />
        )}
        <Body onRemoveItem={onRemoveItem} />
        {shouldRenderCustomerInputSection && <CustomerInputSection />}
        {shouldRenderPriceBreakdown && <PriceBreakdown />}
      </div>
      <div className={classes.footer}>
        <Footer />
      </div>
      <div className={classes.toastContainer}>
        <ErrorToast />
      </div>
    </main>
  );
};
